// @ts-nocheck
class GoogleAnalyticsHelper {
  event (eventName, eventParams = {}) {
    const dataLayer = window.dataLayer || null

    if (!eventName && !dataLayer) {
      return
    }

    dataLayer.push({
      event: eventName,
      ...eventParams
    })
  }
}

export default GoogleAnalyticsHelper
